import { analyticsAllowedAt } from '@/utils/menu/previewMenu'

const UMAMI_SRC = process.env.VUE_APP_UMAMI_SRC
const UMAMI_WEBSITE_ID = process.env.VUE_APP_UMAMI_WEBSITE_ID

// Both env vars present → analytics on; otherwise the whole module is a no-op
// 两个环境变量齐全才启用统计;否则整个模块为 no-op(localhost 即此状态)
// 多版本菜单 B6（U-B6-3，owner D93）：菜单预览页（地址里有 previewMenu 键，不看码对不对）也整个 no-op —— 不注入脚本、不发事件。
// 启动时按地址判一次：没有站内路径能不整页打开就进入预览（见 utils/menu/previewMenu.js）
const enabled = !!(UMAMI_SRC && UMAMI_WEBSITE_ID) && analyticsAllowedAt(window.location.search)

let scriptLoaded = false
const pendingEvents = []

// Inject the Umami tracker. Pageviews (incl. SPA route changes) are
// collected automatically once loaded — no manual pageview calls needed.
// 注入 Umami 统计脚本,加载后自动采集所有页面访问(含 SPA 路由变化),无需手动上报 pageview。
if (enabled) {
  const script = document.createElement('script')
  script.async = true
  script.src = UMAMI_SRC
  script.setAttribute('data-website-id', UMAMI_WEBSITE_ID)
  script.onload = () => {
    scriptLoaded = true
    pendingEvents.forEach(([name, payload]) => window.umami.track(name, payload))
    pendingEvents.length = 0
  }
  document.head.appendChild(script)
}

/**
 * Send a custom event to Umami.
 * Queues the event while the async script is still loading, so events
 * fired right after page entry are not lost.
 * @param {String} name event name
 * @param {Object} [payload] event data shown under the event in the dashboard
 */
/**
 * 向 Umami 发送自定义事件。
 * 脚本(异步)尚未加载完成时先入队,加载完成后补发,保证入口处的事件不丢。
 * @param {String} name 事件名
 * @param {Object} [payload] 事件数据,dashboard 的事件详情里可按字段细分
 */
function umamiTrackEvent(name, payload) {
  if (!enabled) return
  if (scriptLoaded && window.umami) {
    window.umami.track(name, payload)
  } else {
    pendingEvents.push([name, payload])
  }
}

export { umamiTrackEvent }
